module.exports = __webpack_public_path__ + "img/unsplash.12cb2291.jpg";